import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL;


export const fetchDustingReports = (params) => {
  return http.get(`/AdminReports/dusting/orders/page/${(params.page || 0)}`, {
    baseURL: endpoint,
    params,
  });
};

export const fetchDustingReportDetail = (reportId) => {
  return http.get(`/AdminReports/dusting/orders/${reportId}/details`, {
    baseURL: endpoint,
  });
};
export const fetchUserDustingReports = (params) => {
  return http.get(`/AdminReports/dusting/orders/${params.accountId}/page/${(params.page || 0)}`, {
    baseURL: endpoint,
    params,
  });
};
